<template>
  <table class="ui-table mb-16">

    <tr>

      <th>
        <div class="star-pad">
          <UiStar></UiStar>
        </div>
      </th>

      <th>
        <div><SortIcon name="firstName" :ds="ds">{{$t('Payment.applicant')}}</SortIcon></div>
      </th>
      <th>
        <div>{{$t('Payment.status')}}</div>
      </th>
      <th>
        <div>{{$t('Payment.due_date')}}</div>
      </th>
      <th>
        <div>{{$t('Payment.required_amount')}}</div>
      </th>
      <th>
        <div>{{$t('Payment.level')}}</div>
      </th>
      <th>
        <div>{{$t('Payment.paid_amount')}}</div>
      </th>
    </tr>

    <tr
        v-for="item in items"
        :key="item.id"
        @click="$emit('select', item)"
        class="hoverable" :class="{hover: item.id === currentItemId}">

      <td>
        <div class="table-cell star-pad">
          <UiStar :user="item"></UiStar>
        </div>
      </td>

      <td>
        <div class="table-cell nowrap">
          <UiAvatar class="user-avatar" :src="getAvatarUrl(item?.user?.photo?.key)"></UiAvatar>
          <span>
           {{ item.user.firstName }}&nbsp;{{ item.user.middleName }}&nbsp;{{ item.user.lastName }}
            <div class="mini-date nowrap">
              <div class="mini-status">
                <UiStatus :student="item"></UiStatus>
              </div>
              {{ $dayjs(item.createdAt).format('DD/MM/YYYY') }}
            </div>
          </span>
        </div>
      </td>
      <td>
        <UiStatus :student="item"></UiStatus>
      </td>
      <td>
        <div> {{ $dayjs(item.lastStatus.createdAt).add(5, 'day').format('DD/MM/YYYY') }}</div>
      </td>
      <td>
        <div>430€</div>
      </td>
      <td>
        <div>{{$t('Payment.a')}}</div>
      </td>
      <td>
        <div>-</div>
      </td>
    </tr>
  </table>
</template>

<script>
import config from "@/config";
import UiAvatar from "@/components/ui/UiAvatar";
import UiStar from "@/components/ui/UiStar";
import UiStatus from "@/components/ui/UiStatus";
import SortIcon from "@/components/SortIcon";

export default {
  name: "Payment",
  components: {SortIcon, UiStatus, UiStar, UiAvatar},
  props: {
    items: {
      type: Array,
      required: true,
    },
    currentItemId: {},
    ds: {
      type: Object,
      required: true,
    }
  },
  emits: ['select'],
  methods: {
    getAvatarUrl(key) {
      if (key) return `${config.backendUrl}/${key}?token=${localStorage['feathers-jwt']}`;
      else return require('@/assets/images/no-avatar.jpg')
    },
    downloadCV(student) {
      const url = `${config.backendUrl}/${student.cv.key}?token=${localStorage['feathers-jwt']}`
      this.$log(url);
      window.open(url);
    },
  }
}
</script>

<style scoped>

</style>
